import { actions, local$, remote$ } from "./state$";

export const report_builder = {
  local: local$,
  remote: remote$,
  actions,
};
